import {} from "../value/index.js";
import { walkType } from "./walkType.js";
export function occurInType(substitution, name, t) {
    t = walkType(substitution, t);
    switch (t["@kind"]) {
        case "Symbol": {
            return t.name === name;
        }
        case "TypeTerm": {
            return t.args.some((arg) => occurInType(substitution, name, arg));
        }
        default: {
            // TODO
            return false;
        }
    }
}
//# sourceMappingURL=occurInType.js.map